/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

export function ExplanationForm({
  id,
  parentId,
  studentName,
  absenteeismValues,
  setAbsenteeismValues
}) {
  const [absenteeismStatus, setAbsenteeismStatus] = useState();
  const [explanation, setExplanation] = useState();
  const [isApplication, setIsApplication] = useState();
  const [isMail, setIsMail] = useState();
  const [isSms, setIsSms] = useState();

  useEffect(() => {
    const thisValue = absenteeismValues ? absenteeismValues.find(value => value.id === id) : undefined;
    const absenteeismStatus = thisValue ? thisValue.absenteeismStatus : null;
    const explanation = thisValue ? thisValue.explanation : null;
    const isApplication = thisValue ? thisValue.isApplication : null;
    const isMail = thisValue ? thisValue.isMail : null;
    const isSms = thisValue ? thisValue.isSms : null;
    setAbsenteeismStatus(absenteeismStatus);
    setExplanation(explanation);
    setIsApplication(isApplication);
    setIsMail(isMail);
    setIsSms(isSms);
  }, [id, absenteeismValues]);

  return (
    <Form.Control
      type="text"
      value={explanation}
      placeholder="Açıklama"
      onChange={e => {
        const otherValues = absenteeismValues.filter(value => value.id !== id);
        otherValues.push({ id, parentId, studentName, absenteeismStatus, explanation: e.target.value, isApplication, isMail, isSms });
        setAbsenteeismValues(otherValues);
      }}
    />
  )
}